export enum BillsTableStaticActionType {
  Credit = 'credit',
  Delete = 'delete',
  Duplicate = 'duplicate',
  Edit = 'edit',
  RegisterPayment = 'registerPayment',
  RetrySync = 'retrySync',
  Void = 'void',
  VoidPayment = 'voidPayment',
}
